
import { RecoEngineProvider } from "./context/RecoEngineContext";
import RecoEngineBlock from "./components/RecoEngineBlock";
import RecommendationPage from "./pages/RecommendationPage";
import LocationPage from "./pages/LocationPage";

import { importByPageList } from "../../components/StaticWidgets/importPages";

export { RecoEngineProvider } from "./context/RecoEngineContext";
export { default as GeocodingService } from "./services/GeocodingService";

export const ROUTES = {
  RecoPage: { path: "/RecoEngine/RecommendationPage", component: RecommendationPage },
  LocationPage: { path: "/RecoEngine/LocationPage", component: LocationPage },
};

const RecoEngine = () => (
    <RecoEngineProvider>
      <RecoEngineBlock />
    </RecoEngineProvider>
  );

export default RecoEngine;

export const RecoEngineConfig = () => importByPageList("RecoEngine", [RecommendationPage, LocationPage]);
